import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import BaseSearch from '../BaseSearch';
import { useCustomerSearch } from '../../Hooks/useSearch';

const CustomerSearch = forwardRef(({ onChange, placeholder, defaultSelected, id, disabled = false, onBlur }, ref) => {
    const { t } = useTranslation();
    const { search, results } = useCustomerSearch();
    
    const formatLabel = (customer) => {
        const parts = [
            customer.name,
            customer.customerNumber,
            customer.organizationNumber,
            customer.phoneNumber
        ].filter(Boolean);
        
        return parts.join(' / ');
    };

    const attributes = {
        labelKey: formatLabel,
        onSearchAttr: search,
        onChangeAttr: onChange,
        onBlur: onBlur,
        placeholder: placeholder || t('customersearch.placeholder'),
        className: 'form-group search-group search-group-button mb-0',
        disabled: disabled
    };
    
    if (defaultSelected) {
        attributes.defaultSelected = [{ name: defaultSelected }];
    }

    return <BaseSearch ref={ref} attributes={attributes} results={results} id={id} />;
});

CustomerSearch.displayName = 'CustomerSearch';

CustomerSearch.propTypes = {
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    defaultSelected: PropTypes.string,
    id: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    onBlur: PropTypes.func
};

export default CustomerSearch;
